/**
 * Smooth-scrolls the active scroll context (any element marked with
 * `data-jump-scroll-container="true"` first, falling back to `window`) back
 * to the top. Returns `true` if any scroll actually happened, so callers
 * can use it as a "consumed the tap" signal and skip re-navigation.
 *
 * Used by bottom-nav components to give the user the iOS/Twitter-style
 * "tap the active tab to jump to top" affordance without each nav having to
 * know which DOM element scrolls on which page.
 */
export const jumpToTop = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  const containers = document.querySelectorAll('[data-jump-scroll-container="true"]');
  for (const el of containers) {
    if (el && el.scrollTop > 0) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
    }
  }

  if (window.scrollY > 0 || window.pageYOffset > 0) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return true;
  }

  return false;
};

export default jumpToTop;
